import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

/**
 * Panneau noir de présentation affiché à gauche des pages de connexion et d'inscription.
 * Composant générique : le titre et la liste des points forts sont passés en paramètres.
 *
 * @param {string} titre - Début du titre.
 * @param {string} motCle - Mot final mis en valeur en citron.
 * @param {string[]} points - Arguments listés avec une coche.
 */
const AuthAside = ({ titre, motCle, points = [] }) => (
  <aside className="auth-aside">
    <span className="auth-pill">Mercuri Shop</span>
    <h1>{titre} <span className="auth-mark">{motCle}</span></h1>
    <ul>
      {points.map((texte) => (
        <li key={texte}><span className="auth-check"><CheckIcon /></span>{texte}</li>
      ))}
    </ul>
  </aside>
);

export default AuthAside;
